import React, { useEffect, useState } from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import { noop } from '../../../default-props/noop';
import { GuidService } from '../../../services/guid-service';
import style from './radio-check-list-item.module.less';

export const RadioCheckListItem = ({
  id = '',
  children,
  onChecked = noop,
  isChecked = false,
  className,
  isDisabled = false,
  name = 'radioGroup',
  value = '',
}) => {
  const [localId, setLocalId] = useState(id || GuidService.newGuid());

  useEffect(() => {
    if (id) {
      setLocalId(id);
    }
  }, [id]);

  return (
    <div
      className={classnames(className, style['radio-check-button'], {
        [style.disabled]: isDisabled,
      })}
    >
      <input checked={isChecked} disabled={isDisabled} id={localId} name={name} onChange={onChecked} type='radio' value={value} />
      <label
        className={classnames(style['radio-check-button-content'], {
          [style.disabled]: isDisabled,
        })}
        htmlFor={localId}
      >
        <div className={classnames(style['radio-button'], { [style.checked]: isChecked }, { [style.disabled]: isDisabled })} />
        <div>{children}</div>
      </label>
    </div>
  );
};

RadioCheckListItem.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
  onChecked: PropTypes.func,
  isChecked: PropTypes.bool,
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.string,
};
